import { render, staticRenderFns } from "./Fetch.vue?vue&type=template&id=501db0d6"
import script from "./Fetch.vue?vue&type=script&lang=js"
export * from "./Fetch.vue?vue&type=script&lang=js"
import style0 from "./Fetch.vue?vue&type=style&index=0&id=501db0d6&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('501db0d6')) {
      api.createRecord('501db0d6', component.options)
    } else {
      api.reload('501db0d6', component.options)
    }
    module.hot.accept("./Fetch.vue?vue&type=template&id=501db0d6", function () {
      api.rerender('501db0d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/components/formSetting/components/form-create-designer/src/components/Fetch.vue"
export default component.exports